export enum DrawerButtonTypes {
  BUTTON = 'button',
  SUBMIT = 'submit',
  PDF = 'pdf',
  CUSTOM = 'custom',
  BACK = 'back',
  POPUP = 'popup',
  CANCEL = 'cancel',
}
